<div class="popup-container tlms-popup">
	<header>
		<div class="header" style="display:block">{{heading}} Operating Procedure</div>
		<button class="close" style="top:-3px" (click)="close()">
			<mat-icon>close</mat-icon>
		</button>
	</header>

	<ng-container>
		<div style="padding: 16px 24px 16px 24px;">
			<div class="col-12" style="width: 100%;">

				<div class="body">
					<div>
						<label class="catlabel">Description:
							<span style="color:#ff0000">*</span>
						</label>
						<!-- <span class="content"> -->
							<input type="text" id="desc" name="desc" required class="desc" [(ngModel)]="description"
								maxlength="100">
						<!-- </span> -->

					</div>
					<div>
						<label class="catlabel">URL:
							<span style="color:#ff0000">*</span>
						</label>
						<!-- <span class="content"> -->
							<textarea id="url" name="url" required class="url" [(ngModel)]="url"></textarea>
						<!-- </span> -->
					</div>
				</div>

				<label *ngIf="enableError" class="errormsg"> {{errormsg}} </label>
			</div>
		</div>
		<div class="cfooter d-flex justify-content-between align-items-center popup-footer">
			<button (click)="onNoClick()" class="mCancel"> CANCEL
			</button>
			<button class="taskm-submit" style="display: inline" (click)="saveClick()">
				SAVE
			</button>
		</div>
	</ng-container>
</div>